<div
  class="b-f-fileupload"
  [ngClass]="{
    'p-ai-center': props.listPosition === 'bottom' || to.listPosition === 'top',
    'p-flex-column': props.listPosition === 'bottom',
    'p-flex-column-reverse': props.listPosition === 'top',
    'p-flex-row-reverse': props.listPosition === 'left'
  }"
>
  <p-fileUpload
    #fileUpload
    name="myfile[]"
    mode="basic"
    [auto]="true"
    customUpload="true"
    (uploadHandler)="onBasicUploadAuto($event, fileUpload)"
    [chooseIcon]="props.icon + ' material-icons'"
    [chooseLabel]="props.chooseFilesButtonLabel"
    [multiple]="props.multiple"
    [fileLimit]="props.fileLimit"
    [accept]="props.accept ? props.accept : 'image/*'"
    [maxFileSize]="props.maxFileSize ? props.maxFileSize : '5000000'"
    [invalidFileSizeMessageDetail]="
      props.invalidFileSizeMessageDetail
        ? props.invalidFileSizeMessageDetail
        : 'Maximum upload size is 5mb.'
    "
    [invalidFileTypeMessageDetail]="
      props.invalidFileTypeMessageDetail
        ? props.invalidFileTypeMessageDetail
        : 'Only image files are permitted: .jpg, .jpeg, .tif, .tiff, .png'
    "
  >
  </p-fileUpload>

  <div
    class="file-selection"
    [ngClass]="{
      'basin-mr-3': props.listPosition === 'left',
      'basin-ml-3':
        props.listPosition === 'right' ||
        (props.listPosition != 'top' &&
          props.listPosition != 'bottom' &&
          props.listPosition != 'left')
    }"
  >
    <ul style="list-style-type: none" *ngIf="uploadedFiles.length">
      <li
        class="file-line-container"
        *ngFor="let file of uploadedFiles; let i = index"
      >
        <div class="file-icon-and-name">
          <div class="symbol-check-circle-outline file-icon"></div>
          <div class="basin-subtitle-small file-name">{{ file.name }}</div>
        </div>
        <div class="symbol-delete file-delete" (click)="deleteFile(i)"></div>
      </li>
    </ul>
  </div>
</div>
